(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ii-kids-activities"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ii-activity-center')) {
    customElements.define('ii-activity-center', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.cards = Array.from(this.querySelectorAll('[data-activity]'));
        this.controls = this.querySelector('[data-controls]');
        this.search = this.querySelector('[data-search-input]');
        this.readyOnly = this.querySelector('[data-ready-only]');
        this.category = 'all';
        this.controls?.removeAttribute('hidden');
        this.querySelectorAll('[data-filter]').forEach(button => {
          button.hidden = button.dataset.filter !== 'all' && !this.cards.some(card => card.dataset.category === button.dataset.filter);
        });
        this.search?.addEventListener('input', () => this.filter(), { signal });
        this.readyOnly?.addEventListener('change', () => this.filter(), { signal });
        this.addEventListener('click', event => {
          const target = event.target instanceof Element ? event.target : null;
          const filter = target?.closest('[data-filter]');
          if (filter) { this.category = filter.dataset.filter; this.filter(); }
          if (target?.closest('[data-reset]')) this.reset(true);
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = event.target.closest?.('[data-activity]');
          if (!card || !this.contains(card)) return;
          this.reset(false);
          card.scrollIntoView({ behavior: 'auto', block: 'center' });
        }, { signal });
        this.filter();
      }
      disconnectedCallback() { this.controller?.abort(); }
      normalize(value) { return (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(); }
      reset(focusSearch) {
        if (this.search) this.search.value = '';
        if (this.readyOnly) this.readyOnly.checked = false;
        this.category = 'all';
        this.filter();
        if (focusSearch) this.search?.focus({ preventScroll: true });
      }
      filter() {
        const terms = this.normalize(this.search?.value).trim().split(/\s+/).filter(Boolean);
        let visible = 0, ready = 0;
        this.cards.forEach(card => {
          const text = this.normalize(card.dataset.search);
          const matches = (this.category === 'all' || card.dataset.category === this.category)
            && (!this.readyOnly?.checked || card.dataset.ready === 'true')
            && terms.every(term => text.includes(term));
          card.hidden = !matches;
          if (matches) { visible++; if (card.dataset.ready === 'true') ready++; }
        });
        this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.category)));
        const count = this.querySelector('[data-count]');
        if (count) count.textContent = `${visible} ${visible === 1 ? 'activity' : 'activities'} · ${ready} ready to download`;
        const empty = this.querySelector('[data-no-results]');
        if (empty) empty.hidden = this.cards.length === 0 || visible > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ii-kids-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ii-community-page')) {
    customElements.define('ii-community-page', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick, { signal });
        this.addEventListener('toggle', (event) => {
          const opened = event.target;
          if (this.dataset.singleFaq !== 'true' || !(opened instanceof HTMLDetailsElement) || !opened.open) return;
          const group = opened.closest('.ic-faq');
          group?.querySelectorAll('details[open]').forEach(item => { if (item !== opened) item.open = false; });
        }, { capture: true, signal });
        const dialog = this.querySelector('.ic-dialog');
        dialog?.addEventListener('close', () => this.previewTrigger?.focus({ preventScroll: true }), { signal });
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) event.target.scrollIntoView({ block: 'center', behavior: 'auto' });
        }, { signal });
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.motion === 'true' && this.dataset.editor !== 'true' && !reduced && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('ic-enter');
              this.observer.unobserve(entry.target);
            });
          }, { threshold: 0.12 });
          this.querySelectorAll('.ic-resource-header, .ic-resource, .ic-band--story .ic-header').forEach(el => this.observer.observe(el));
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        const dialog = this.querySelector('.ic-dialog');
        if (dialog?.open) dialog.close();
      }
      onClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const dialog = this.querySelector('.ic-dialog');
        if (target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          return;
        }
        const anchor = target.closest('a');
        if (!anchor || !this.contains(anchor) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey || anchor.target === '_blank') return;
        if (anchor.hasAttribute('data-ic-preview') && dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          const image = dialog.querySelector('.ic-dialog-image');
          const sourceImage = anchor.querySelector('img');
          image.src = anchor.href;
          image.alt = sourceImage?.alt || anchor.dataset.caption || '';
          dialog.querySelector('.ic-dialog-caption').textContent = anchor.dataset.caption || '';
          this.previewTrigger = anchor;
          dialog.showModal();
          return;
        }
        const href = anchor.getAttribute('href');
        if (!href?.startsWith('#') || href.length < 2) return;
        let id;
        try { id = decodeURIComponent(href.slice(1)); } catch { return; }
        const destination = document.getElementById(id);
        if (!destination || (destination !== this && !this.contains(destination))) return;
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        destination.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        if (!destination.hasAttribute('tabindex')) {
          destination.setAttribute('tabindex', '-1');
          destination.addEventListener('blur', () => destination.removeAttribute('tabindex'), { once: true });
        }
        destination.focus({ preventScroll: true });
        try { history.pushState(null, '', href); } catch { /* Native links still work without history access. */ }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ii-kids-product-template"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ii-simple-product')) {
    customElements.define('ii-simple-product', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort(); this.controller = new AbortController();
        const { signal } = this.controller;
        const stages = Array.from(this.querySelectorAll('[data-image]'));
        const selectImage = id => {
          if (!stages.some(stage => stage.dataset.image === id)) return;
          stages.forEach(stage => { stage.hidden = stage.dataset.image !== id; stage.style.marginTop = '0'; });
          this.querySelectorAll('[data-thumb]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.thumb === id)));
        };
        selectImage(this.dataset.initialImage || stages[0]?.dataset.image);
        this.querySelector('[data-thumbs]')?.removeAttribute('hidden');
        this.addEventListener('click', event => {
          const button = event.target.closest?.('[data-thumb]');
          if (button) selectImage(button.dataset.thumb);
        }, { signal });
        this.querySelector('[data-variant-selector]')?.addEventListener('change', event => {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', event.target.value);
          window.location.assign(url.toString());
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const details = event.target.closest?.('details');
          if (details) details.open = true;
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
